import React from 'react'
import PropTypes from 'prop-types'
import { ConfigProvider } from 'antd'
import i18n from '../i18n'
import zh_CN from 'antd/lib/locale-provider/zh_CN'
import en_US from 'antd/lib/locale-provider/en_US'

class ConfigProviderWithLocale extends React.Component {
    static props = {
        locale: PropTypes.object
    }

    constructor(props) {
        super(props)
        this.state = {
            locale: props.locale
        }

        i18n.on('languageChanged', (lng) => {
            this.setState({
                locale: lng
            })
        })
    }

    render() {
        const { locale } = this.state

        return (
            <ConfigProvider locale={locale === 'zh' ? zh_CN : en_US}>
                {this.props.children}
            </ConfigProvider>
        )
    }
}

export default ConfigProviderWithLocale
